import MatrixHeaderContainer from './MatrixHeader';

export default MatrixHeaderContainer;
